
import "./pControllingExport/pControllingExport.sass";
import "./pIncomeImport/pIncomeImport.sass";
import "./pRates/pRates.sass";

import { pRatesDirective } from './pRates/pRates.directive';
import { pIncomeImportDirective } from './pIncomeImport/pIncomeImport.directive';
import { pControllingExportDirective } from './pControllingExport/pControllingExport.directive';

import { ControllingService } from './Controlling.service';

export default angular.module('frontend.controlling', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pRates', pRatesDirective)
  .directive('pIncomeImport', pIncomeImportDirective)
  .directive('pControllingExport', pControllingExportDirective)
  .service('Controlling', ControllingService);
